import uniqBy from 'lodash/uniqBy';

export function fetchMoreStudents(data) {
  const keyName = data?.paginatedStudents ? 'paginatedStudents' : 'paginatedStudentTestStatus'; // reason we are doing this is to have reusable code for both paginatedStudents and paginatedStudentTestStatus
  const { lastKey } = data?.[keyName] || {};

  return lastKey
    ? {
        variables: {
          input: { startKey: lastKey, limit: 5000 },
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult || !fetchMoreResult?.[keyName] || !fetchMoreResult?.[keyName].students) {
            return {
              ...prev,
              [keyName]: {
                ...prev[keyName],
                students: uniqBy([...prev[keyName].students], 'id'),
                lastKey: null,
              },
            };
          }
          return {
            ...prev,
            [keyName]: {
              ...prev[keyName],
              students: uniqBy(
                [...(prev?.[keyName]?.students || []), ...(fetchMoreResult?.[keyName]?.students || [])],
                'id'
              ),
              lastKey: fetchMoreResult?.[keyName]?.lastKey,
            },
          };
        },
      }
    : undefined;
}
